import React, {useState} from 'react';
import {Link, useLocation} from 'react-router-dom';
import CheckRole from './CheckRole';
import sidebarStyles from '../components/css/sidebar.module.css';
import logo from '../assets/images/logo.png';

const Sidebar = ({handleLogout}) => {
    const location = useLocation();
    const [activeDropdown, setActiveDropdown] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false); // Estado para controlar o menu em telas pequenas

    const toggleDropdown = (menu) => {
        setActiveDropdown((prev) => (prev === menu ? null : menu));
    };

    const toggleMenu = () => {
        setMenuOpen(!menuOpen); // Alterna entre aberto e fechado
    };

    const isMenuActive = (path) => location.pathname.includes(path);




    const renderMenuItem = (menu, submenus, roles) => (
        <CheckRole roles={roles}>
            <div
                className={`${sidebarStyles.menuGroup} ${
                    activeDropdown === menu || submenus.some((submenu) => isMenuActive(submenu.path))
                        ? sidebarStyles.active
                        : ''
                }`}
            >
                <span className={sidebarStyles.menuTitle} onClick={() => toggleDropdown(menu)}>
                    {menu}
                </span>
                {activeDropdown === menu && (
                    <div className={sidebarStyles.submenu}>

                        {submenus.map((submenu) => (
                            <CheckRole key={submenu.path} roles={submenu.roles ?? roles}>
                            <Link
                                    to={submenu.path}
                                    className={`${sidebarStyles.submenuItem} ${
                                        isMenuActive(submenu.path)
                                            ? sidebarStyles.submenuItemActive
                                            : ''
                                    }`}
                                >
                                    {submenu.label}
                                </Link>
                            </CheckRole>
                        ))}

                    </div>
                )}
            </div>
        </CheckRole>
    );

    return (
        <div className={sidebarStyles.sidebar}>
            {/* Logo */}
            <div className={sidebarStyles.logoContainer}>
                <img src={logo} alt="Hello Sol" className={sidebarStyles.logoImage}/>
            </div>

            {/* Menu */}
            <nav className={`${sidebarStyles.menu} ${menuOpen ? sidebarStyles.active : ''}`}>
                {renderMenuItem(
                    'Dashboard',
                    [
                        {path: '/home/dashboard', label: 'Dashboard', roles: ['ADMINISTRADOR'] },
                        {path: '/home/rateio-dashboard', label: '📊 Dashboard Rateio', roles: ['ADMINISTRADOR', 'GESTOR'] },
                        {path: '/home/auditoria-distribuidora', label: '📊 Auditoria Distribuidora', roles: ['ADMINISTRADOR', 'GESTOR'] },
                    ],
                    ['ADMINISTRADOR', 'GESTOR']
                )}
                {renderMenuItem(
                    'Robo',
                    [
                        { path: '/home/neoenergia-df', label: 'Captura Neoenergia DF', roles: ['ADMINISTRADOR'] },
                        { path: '/home/listar-status-faturas', label: 'Status da Importacao', roles: ['ADMINISTRADOR', 'GESTOR', 'FUNCIONARIO'] },
                        { path: '/home/listar-status-faturas-empresa', label: 'Pendencias por Empresa', roles: ['ADMINISTRADOR', 'GESTOR', 'FUNCIONARIO'] },
                        { path: '/home/listar-cliente-consumo', label: 'Consumos Gerados', roles: ['ADMINISTRADOR', 'GESTOR', 'FUNCIONARIO'] }
                    ],
                    ['ADMINISTRADOR', 'GESTOR', 'FUNCIONARIO']
                )}
                {renderMenuItem(
                    'Empresa',
                    [
                        { path: '/home/cadastrar-empresa', label: 'Cadastrar', roles: ['ADMINISTRADOR'] },
                        { path: '/home/listar-empresa',    label: 'Consultar', roles: ['ADMINISTRADOR','GESTOR'] },
                    ],
                    ['ADMINISTRADOR', 'GESTOR']
                )}
                {renderMenuItem(
                    'Usuário',
                    [
                        {path: '/home/cadastrar-usuario', label: 'Cadastrar', roles: ['ADMINISTRADOR', 'GESTOR', 'FUNCIONARIO'] },
                        {path: '/home/listar-usuario', label: 'Consultar', roles: ['ADMINISTRADOR', 'GESTOR', 'FUNCIONARIO'] },
                    ],
                    ['ADMINISTRADOR', 'GESTOR']
                )}
                {renderMenuItem(
                    'Usina',
                    [
                        {path: '/home/cadastrar-usina', label: 'Cadastrar', roles: ['ADMINISTRADOR', 'GESTOR', 'FUNCIONARIO'] },
                        {path: '/home/listar-usina', label: 'Consultar', roles: ['ADMINISTRADOR', 'GESTOR', 'FUNCIONARIO'] },
                    ],
                    ['ADMINISTRADOR', 'GESTOR']
                )}
                {renderMenuItem(
                    'Unidade Consumidora',
                    [
                        {path: '/home/cadastrar-unidade-consumidora', label: 'Cadastrar', roles: ['ADMINISTRADOR', 'GESTOR', 'FUNCIONARIO'] },
                        {path: '/home/listar-unidade-consumidora', label: 'Consultar', roles: ['ADMINISTRADOR', 'GESTOR', 'FUNCIONARIO'] },
                    ],
                    ['ADMINISTRADOR', 'GESTOR']
                )}
                {renderMenuItem(
                    'Rateio',
                    [
                        {path: '/home/cadastrar-rateio', label: 'Cadastrar', roles: ['ADMINISTRADOR', 'GESTOR', 'FUNCIONARIO'] },
                        {path: '/home/listar-rateio', label: 'Consultar', roles: ['ADMINISTRADOR', 'GESTOR', 'FUNCIONARIO'] },
                        {path: '/home/rateio-analise', label: '⚙️ Análise Inteligente', roles: ['ADMINISTRADOR', 'GESTOR', 'FUNCIONARIO'] },
                    ],
                    ['ADMINISTRADOR', 'GESTOR', 'FUNCIONARIO']
                )}
                {renderMenuItem(
                    'Produção Usina',
                    [
                        {path: '/home/cadastrar-producao-usina', label: 'Cadastrar', roles: ['ADMINISTRADOR', 'GESTOR', 'FUNCIONARIO'] },
                        {path: '/home/listar-producao-usina', label: 'Consultar', roles: ['ADMINISTRADOR', 'GESTOR', 'FUNCIONARIO'] },
                    ],
                    ['ADMINISTRADOR', 'GESTOR', 'FUNCIONARIO']
                )}

                {renderMenuItem(
                    'Importar Fatura',
                    [
                        { path: '/home/importar-faturas', label: 'Importar (PDF)', roles: ['ADMINISTRADOR','GESTOR','FUNCIONARIO'] },
                        { path: '/home/listar-faturas',   label: 'Consultar',     roles: ['ADMINISTRADOR','GESTOR','FUNCIONARIO'] }, // opcional
                    ],
                    ['ADMINISTRADOR','GESTOR','FUNCIONARIO']
                )}

                {renderMenuItem(
                    'Consumo Cliente',
                    [
                        {path: '/home/cadastrar-cliente-consumo', label: 'Cadastrar', roles: ['ADMINISTRADOR', 'GESTOR', 'FUNCIONARIO'] },
                        {path: '/home/listar-cliente-consumo', label: 'Consultar', roles: ['ADMINISTRADOR', 'GESTOR', 'FUNCIONARIO'] },
                    ],
                    ['ADMINISTRADOR', 'GESTOR', 'FUNCIONARIO']
                )}

                {renderMenuItem(
                    'Relatórios',
                    [
                        {path: '/home/listar-faturamento', label: 'Faturamento (Contabilidade)', roles: ['ADMINISTRADOR', 'GESTOR', 'FUNCIONARIO'] },
                        {path: '/home/listar-economia-mensal', label: 'Economia Mensal', roles: ['ADMINISTRADOR', 'GESTOR', 'FUNCIONARIO'] },
                        { path: '/home/listar-status-faturas-empresa', label: 'Faturas Geradas x Pendentes', roles: ['ADMINISTRADOR', 'GESTOR', 'FUNCIONARIO'] },
                        { path: '/home/listar-status-faturas', label: 'Faturas Geradas por Usina', roles: ['ADMINISTRADOR', 'GESTOR', 'FUNCIONARIO'] },
                        {path: '/home/listar-consumo-producao', label: 'Consumo x Produção', roles: ['ADMINISTRADOR'] },
                        {path: '/home/listar-receita-cliente', label: 'Receita por Cliente', roles: ['ADMINISTRADOR'] },
                    ],
                    ['ADMINISTRADOR', 'GESTOR', 'FUNCIONARIO']
                )}
            </nav>

            {/* Botão de Logout */}
            <div className={sidebarStyles.footer}>
                <button className={sidebarStyles.logoutButton} onClick={handleLogout}>
                    Sair
                </button>
            </div>
        </div>
    );
};

export default Sidebar;
